export function formatInt(n: number): string {
  return n.toLocaleString("pt-BR");
}

export function formatPct(n: number): string {
  return `${(n * 100).toFixed(1)}%`;
}

export function fromUnix(sec: number | null | undefined): string {
  if (!sec) return "—";
  return new Date(sec * 1000).toISOString().slice(0, 16).replace("T", " ");
}
